module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a3@2x_d9fae35d8192bfc88358ef8caeef469c.png";